import { render, staticRenderFns } from "./SharedSpaceWarningModal.vue?vue&type=template&id=385c9c25"
import script from "./SharedSpaceWarningModal.vue?vue&type=script&lang=js"
export * from "./SharedSpaceWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports